import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  title?: string;
  subtitle?: string;
  hours?: number;
}
export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  title = 'El precio de lanzamiento termina en:',
  subtitle = 'Después sube $8.000 ARS y no vuelve a bajar.',
  hours = 24
}) => {
  // Set initial time to 24 hours from now
  const [timeLeft, setTimeLeft] = useState(hours * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return {
      hours: h.toString().padStart(2, '0'),
      minutes: m.toString().padStart(2, '0'),
      seconds: s.toString().padStart(2, '0')
    };
  };
  const {
    hours: h,
    minutes: m,
    seconds: s
  } = formatTime(timeLeft);
  return <div className="w-full max-w-md mx-auto my-4 md:my-8" data-id="element-498">
      <div className="bg-[#1A1A1A] rounded-xl p-4 md:p-6 text-center shadow-xl border border-red-900/30 relative overflow-hidden" data-id="element-499">
        {/* Subtle pulse effect in background */}
        <div className="absolute inset-0 bg-red-500/5 animate-pulse" data-id="element-500"></div>

        <p className="text-red-400 font-semibold mb-3 md:mb-4 text-xs md:text-sm uppercase tracking-wider relative z-10" data-id="element-501">
          {title}
        </p>

        <div className="flex justify-center items-center gap-2.5 md:gap-4 mb-3 md:mb-4 relative z-10" data-id="element-502">
          <div className="flex flex-col items-center" data-id="element-503">
            <div className="bg-black/50 rounded-lg w-12 h-12 md:w-16 md:h-16 flex items-center justify-center border border-gray-800" data-id="element-504">
              <span className="text-2xl md:text-3xl font-bold text-white font-serif" data-id="element-505">
                {h}
              </span>
            </div>
            <span className="text-[10px] md:text-xs text-gray-400 mt-1 md:mt-2 uppercase" data-id="element-506">
              Horas
            </span>
          </div>
          <span className="text-xl md:text-2xl text-red-500 font-bold -mt-4 md:-mt-6" data-id="element-507">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-508">
            <div className="bg-black/50 rounded-lg w-12 h-12 md:w-16 md:h-16 flex items-center justify-center border border-gray-800" data-id="element-509">
              <span className="text-2xl md:text-3xl font-bold text-white font-serif" data-id="element-510">
                {m}
              </span>
            </div>
            <span className="text-[10px] md:text-xs text-gray-400 mt-1 md:mt-2 uppercase" data-id="element-511">
              Min
            </span>
          </div>
          <span className="text-xl md:text-2xl text-red-500 font-bold -mt-4 md:-mt-6" data-id="element-512">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-513">
            <div className="bg-black/50 rounded-lg w-12 h-12 md:w-16 md:h-16 flex items-center justify-center border border-gray-800" data-id="element-514">
              <span className="text-2xl md:text-3xl font-bold text-white font-serif" data-id="element-515">
                {s}
              </span>
            </div>
            <span className="text-[10px] md:text-xs text-gray-400 mt-1 md:mt-2 uppercase" data-id="element-516">
              Seg
            </span>
          </div>
        </div>

        <p className="text-gray-300 text-xs md:text-sm font-medium relative z-10" data-id="element-517">
          {subtitle}
        </p>

        <div className="mt-4 md:mt-6 relative z-10" data-id="element-518">
          <div className="flex justify-between text-[10px] md:text-xs mb-1" data-id="element-519">
            <span className="text-red-400 font-semibold" data-id="element-520">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-white font-bold" data-id="element-521">68% tomados</span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-2" data-id="element-522">
            <div className="bg-red-500 h-2 rounded-full" style={{
            width: '68%'
          }} data-id="element-523"></div>
          </div>
        </div>
      </div>
    </div>;
};